// extracted by mini-css-extract-plugin
module.exports = {"modal_content":"ApproveConsumptionModal_modal_content__N9y0B","modal_header":"ApproveConsumptionModal_modal_header__3VCy0","modal_body":"ApproveConsumptionModal_modal_body__2h-VT"};